// Shared validation for the "share quote via email" forms (Share page and
// the Quotes page "Sent Invitations" modal). First and last name are
// mandatory (backend strict mode) and limited to 100 characters each.
export const SHARE_NAME_MAX_LENGTH = 100;

export interface IShareQuoteFormFields {
    email: string;
    firstName: string;
    lastName: string;
}

export interface IShareQuoteFormValidation {
    valid: boolean;
    message?: string;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateShareQuoteForm = ({
    email,
    firstName,
    lastName,
}: IShareQuoteFormFields): IShareQuoteFormValidation => {
    if (!email.trim()) {
        return { valid: false, message: "Please enter an email address" };
    }
    if (!EMAIL_REGEX.test(email.trim())) {
        return { valid: false, message: "Please enter a valid email address" };
    }
    if (!firstName.trim() || !lastName.trim()) {
        return { valid: false, message: "Please enter a first and last name" };
    }
    if (
        firstName.trim().length > SHARE_NAME_MAX_LENGTH ||
        lastName.trim().length > SHARE_NAME_MAX_LENGTH
    ) {
        return {
            valid: false,
            message: "First and last name must be 100 characters or less",
        };
    }
    return { valid: true };
};
